export class CreatePlaylistForm {
    public id: string = '';
    public name: string = '';
    public type: string = 'P';
    public visibility: string = 'Public';
    public description: string = '';
    public bio: string = '';
    public song_id: string = '';
    public created_by: string = '';
   // public playlist_image: string = '';

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/models/create-playlist-form.ts